import React, {Component} from 'react';
import {Button} from 'reactstrap'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Mutation, Query} from 'react-apollo'
import {toast} from "react-toastify";

import NotificationListContainer from "./NotificationListContainer"
import NotificationInput from './NotificationInput'
import ConfirmModal from '../ConfirmModal'

import createNotificationMutation from '../../../queries/server/mutations/create_notification'
import deactivateNotification from '../../../queries/server/mutations/deactivate_notification'
import editNotificationMutationClient from '../../../queries/client_side/mutations/edit_notification'
import notificationQuery from '../../../queries/server/notification'
import {
  checkPermission, 
  NOTIFICATIONS_CAN_CREATE_NOTIFICATIONS, 
  NOTIFICATIONS_CAN_EDIT_NOTIFICATIONS,
  NOTIFICATIONS_CAN_REMOVE_NOTIFICATIONS,
} from '../../../lib/permissions'

export default class Notifications extends Component {

  state = {
    showInput: false,
    showEditInput: false,
    selectedNotification: null,
    showConfirmDelete: false,
    deleteNotificationID: null,
    subject: '',
    message: '',
    office_id: null,
    popup: false
  }

  toggle = () => {
    this.setState({ showInput: !this.state.showInput})
  }

  toggleEdit = () => {
    this.setState({ showEditInput: !this.state.showEditInput})
  }

  toggleConfirmDelete = () => {
    this.setState({ showConfirmDelete: !this.state.showConfirmDelete})
  }

  onDelete = (id) => {
    this.setState({showConfirmDelete: true, deleteNotificationID: id})
  }

  handleDelete = () => {
    this.setState({showConfirmDelete: false, deleteNotificationID: null})
  }

  onChange = ({key, value}) => {
    this.setState({[key]: value})
  }

  onNotificationSelected = (id) => {
    this.setState({showEditInput: true, selectedNotification: id})
  }

  saveSuccess = () => {
    this.setState({
      showInput: false,
      subject: '',
      message: '',
      office_id: null,
      popup: false
    })
  }

  editSuccess = () => {
    this.setState({
      showEditInput: false,
      selectedNotification: null,
      subject: '',
      message: '',
      office_id: null,
      popup: false
    })
  }

  componentWillUnmount(){
    this.props.setTimeOnUnmount()
  }

  render(){
    const {state, props, toggle, onChange, saveSuccess, editSuccess, toggleEdit, toggleConfirmDelete, onNotificationSelected, onDelete, handleDelete} = this
    const {showInput, showEditInput, selectedNotification, showConfirmDelete, deleteNotificationID} = state
    const {user} = props

    return(
      <div>
        <div className="d-flex flex-column p-3">
          <div className="d-flex justify-content-between flex-row align-items-center">
            <h1>Notifications</h1>
            {checkPermission(NOTIFICATIONS_CAN_CREATE_NOTIFICATIONS) && 
            <Button
              size="sm"
              color={showInput ? 'warning' : 'success'}
              onClick={toggle}
            >
                <FontAwesomeIcon color="#fff"
                                  icon={showInput ? 'minus' : 'plus'}/>{' '}
                {showInput ? 'Cancel' : 'Add Notification'}
            </Button>}
          </div>
          <NotificationListContainer 
            onEdit={onNotificationSelected} 
            canEdit={checkPermission(NOTIFICATIONS_CAN_EDIT_NOTIFICATIONS)}
            onDelete={onDelete} 
            canDelete={checkPermission(NOTIFICATIONS_CAN_REMOVE_NOTIFICATIONS)}
            office_id={user.office_id}
          />
        </div>
        <Mutation 
          mutation={createNotificationMutation}
          update={(cache, {data: {upsertNotification}}) => {
            /*const original = cache.readQuery({query})
            cache.writeQuery({
                query,
                data: {
                  ...original,
                  notifications: [
                    upsertNotification,
                    ...original.notifications
                  ]
                }
            })*/
          }}
        >
          {(upsertNotification, {loading}) => {
            return (
              <div>
                <NotificationInput 
                  title="Create Notification" 
                  loading={false}
                  saving={loading}
                  isOpen={showInput} 
                  toggle={toggle} 
                  onChange={onChange}
                  onSave={({subject, message, office_id, popup}) => 
                    upsertNotification({variables: {data: {subject, message, office_id: office_id || null, popup}}}).then(saveSuccess)}
                      
                  {...state}
                />

                {showEditInput && 
                  selectedNotification && 
                  <Query query={notificationQuery} variables={{id: selectedNotification}}>
                    {(notificationResult) => {
                      const data = 
                        (!notificationResult.loading && notificationResult.data) ? 
                          notificationResult.data.notification : 
                          {}

                      return (
                        <Mutation mutation={editNotificationMutationClient}>
                          {(localMutationFunc) => (
                            <NotificationInput
                              loading={notificationResult.loading}
                              saving={loading}
                              title="Edit Notification"
                              {...data}
                              isOpen={showEditInput}
                              toggle={toggleEdit}
                              onChange={({key, value}) => {
                                localMutationFunc({variables: {
                                  data: {
                                    ...data,
                                    [key]: value
                                  }
                                }})
                              }}
                              onSave={({id, subject, message, office_id, popup}) => {
                                upsertNotification({variables: {data: {id, subject, message, office_id: office_id || null, popup}}}).then(editSuccess)
                              }}
                            />
                          )}
                        </Mutation>
                        
                      )
                    }}
                  </Query>}
              </div>
              
            )
          }}
        </Mutation>
        <Mutation mutation={deactivateNotification}>
          {(deactivateFunc, {loading}) => (
            <ConfirmModal
              isOpen={showConfirmDelete}
              toggle={toggleConfirmDelete}
              title="Confirm Delete Notification"
              message="Are you sure you want to delete this notification?"
              saving={loading}
              onConfirm={() => {
                deactivateFunc({variables: {id: deleteNotificationID}})
                  .then(handleDelete)
              }}
            />
          )}
        </Mutation>
        
      </div>
      
    )
  }
}
